import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-pegination',
  templateUrl: './pegination.component.html',
  styleUrls: ['./pegination.component.css']
})
export class PeginationComponent implements OnChanges {
  @Input() pageAll = 1;
  @Input() totalPages = 1;
  @Input() pageSize = 10;

  @Output() pageChange = new EventEmitter<number>();
  @Output() sizeChange = new EventEmitter<number>();

  pages: (number | string)[] = [];
  jumpPageInput = 1;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['pageAll'] || changes['totalPages']) {
      this.updateVisibleAllPages();
    }
  }

  goToPage(pageNumber: number | string): void {
    if (typeof pageNumber !== 'number') return;
    if (pageNumber >= 1 && pageNumber <= this.totalPages) {
      this.pageChange.emit(pageNumber);
    }
  }

  jumpToPage(): void {
    if (this.jumpPageInput >= 1 && this.jumpPageInput <= this.totalPages) {
      this.pageChange.emit(this.jumpPageInput);
    } else {
      alert(`Enter a page number between 1 and ${this.totalPages}`);
    }
  }

  onSizeChange(size: number): void {
    this.sizeChange.emit(size);
  }

 private updateVisibleAllPages(): void {
  const pages: (number | string)[] = [];

  if (this.totalPages <= 6) {
    for (let i = 1; i <= this.totalPages; i++) {
      pages.push(i);
    }
  } else {
    const maxVisible = 5;
    const half = Math.floor(maxVisible / 2);

    let start = this.pageAll - half;
    let end = this.pageAll + half;

    // Ensure window stays within range
    if (start < 1) {
      start = 1;
      end = start + (maxVisible - 1);
    }
    if (end > this.totalPages - 1) {
      end = this.totalPages - 1;
      start = end - (maxVisible - 1);
    }

    // Add middle pages (no 1, no start dots)
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    // Add right dots if needed
    if (end < this.totalPages - 1) {
      pages.push('...');
    }

    // Always show last page
    pages.push(this.totalPages);
  }

  this.pages = pages;
}

}
